module.exports = __webpack_public_path__ + "ca8adb8c9304d03710e22ad8c5a6c462.jpg";